<div [style.fontFamily]="app.languageService.selectedContentLanguage.FontFamily">

    <div class="layout-main">
        <app-ws-topbar></app-ws-topbar>

        <main class="layout-content p-0">
            <router-outlet></router-outlet>
        </main>

        <app-ws-footer></app-ws-footer>
        <div class="layout-main-mask"></div>
    </div>

</div>